// src/components/common/SparkCard.tsx

import React from 'react';

interface SparkCardProps {
  children: React.ReactNode;
  variant?: 'glass' | 'solid';
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const SparkCard: React.FC<SparkCardProps> = ({
  children,
  variant = 'glass',
  className = '',
  style = {},
  onClick,
}) => {
  const cardClasses = [
    'spark-card',
    variant === 'solid' ? 'spark-card--solid' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div 
      className={cardClasses} 
      style={style}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="spark-card__content">
        {children}
      </div>
    </div>
  );
};

export default SparkCard;